import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { MSpinner, MSelect } from "components/Shared";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";
import {
  workflowMethod,
  setWorkflowMonitor,
  getWorkflowStatus,
} from "actions/homeowner/caseforms";

import { postAppraiserFeedback, getAppraiserFeedback } from "requests/caseFeedback";
import { categoryCodes } from "typeConstants/caseFeedbackCategoryCodes";
import logo from "static/images/logo.png";
import StarRatings from "react-star-ratings";
import responseHandler from "responseHandler";
import {APPRAISAL_SUBMIT_FEEDBACK_REQUIRED, COLLATERAL_ANALYTICS_RISK_PROFILER, APPRAISER_ADD_INCIDENT} from "typeConstants/rights";
import moment from "moment-timezone";
import { generateSsoParametersRiskProfiler} from "requests/collateralAnalytics";
import { appraisalWorkflowStatusTypeEnum } from "typeConstants/appraisalWorkflowStatusType";
import { DialogContext } from "components/Shared/DialogProvider.tsx";
import { addAppraiserRejections, getAppraiserRejections } from "requests/appraiser";
import { appraiserReasonOptions } from "typeConstants/customerService/index";
import TimeLogFeedback from "./TimeLogFeedback";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  ACE_PDR_CONVERT_TO_APPRAISAL_1004_HYBRID,
  ACE_PDR_CONVERT_TO_APPRAISAL_70H,
} from "typeConstants/customerFeatureSettings";
class CaseAction extends AppInsightsTracker {
	static contextType = DialogContext;
  constructor(props) {
    super(props);
    this.displayName = "CaseAction";
    this.state = {
      isVisible: false,
      workingMessage: "",
      addTimeLogsDialogBoxVisible: false,
      displayingAppraisalSurvey: false,
      fieldRepRating: {},
      operationsManagerRating: {},
      muellerTechRating: {},
      ratingComment: "",
      isFeedbackRequired: null,
      rejectToQaReason: null,
      rejectToQaNotes: null,
      appraiserRejections: [],
      displayFeedbackDialog: false,
      alternateMethod: null,
      commentFieldValue: null
    };

    this.confirmHandler = this.confirmHandler.bind(this);
    this.hideActionDialog = this.hideActionDialog.bind(this);
    this.showActionDialog = this.showActionDialog.bind(this);
    this.displayAddTimeLogs = this.displayAddTimeLogs.bind(this);
    this.displayAppraisalSurvey = this.displayAppraisalSurvey.bind(this);
    this.submitAppraisalRatingSurvey = this.submitAppraisalRatingSurvey.bind(this);
    this.startSubmitAppraiserRating = this.startSubmitAppraiserRating.bind(this);
    this.setIsFeedbackRequired = this.setIsFeedbackRequired.bind(this);
    this.showCollateralAnalyticsSso = this.showCollateralAnalyticsSso.bind(this);
    this.showCollateralAnalyticsSsoWindow = this.showCollateralAnalyticsSsoWindow.bind(this);
    this.showRejectToQaDialog = this.showRejectToQaDialog.bind(this);
    this.checkForFeedback = this.checkForFeedback.bind(this);
    this.mounted = { current: true };
    this.fetchingWorkflowStatus = {
      initiatedCall: false,
      running: false,
      started: null,
    };
  }

  componentDidMount() {
    const { controlNumber, profile } = this.props;
    if (controlNumber) {
      getAppraiserFeedback(controlNumber, this.setIsFeedbackRequired, this.mounted);
      const getAppraiserRejectionsCallback = (resp) => this.setState({appraiserRejections: resp});
      if (profile.rights.includes(APPRAISER_ADD_INCIDENT)) {
        getAppraiserRejections(controlNumber, this.mounted, getAppraiserRejectionsCallback);
      }else{
        getAppraiserRejectionsCallback([]);
      }
    }
  }

  componentWillUnmount() {
    this.mounted.current = false;
  }

  setIsFeedbackRequired(result) {
    this.setState({
      isFeedbackRequired: result,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let wf = nextProps.workflowMonitor;
    if (wf && wf.display && !nextProps.fetchingWorkflowStatus) {
      let oldStatus = this.props.workflowStatus.appraisalWorkflowStatusId;
      let newStatus = nextProps.workflowStatus.appraisalWorkflowStatusId;
      if (oldStatus !== newStatus && this.state.isVisible) {
        switch (newStatus) {
          case appraisalWorkflowStatusTypeEnum.PENDING_APPRAISAL_QA:
            this.props.makeSuccessToast("Submission Successful!");
            break;
          case appraisalWorkflowStatusTypeEnum.VEROS_PREVIEW_ERROR_APPRAISER:
            this.props.makeErrorToast("Veros Submission Complete. Please review results.");
            break;
        }
      }

      // SD-14745 getWorkflowStatus was being called repeatedly from every single action button visible
      // Check to see if this button is the one that initiated the workflow action
      const initiatedCall = wf.initiatedByButtonText === this.props.buttonText && this.mounted.current;
      this.fetchingWorkflowStatus.initiatedCall = initiatedCall;
      if (!initiatedCall) return;
      // Need to start with a validation?
      if (wf.validation.required && !wf.validation.started) {
        this.props.validateForms(this.props.controlNumber);
        this.setState({
          workingMessage: "Validating Forms before " + wf.workingMessage + "."
        });
      }

      // Ready to try the workflow method?
      if (!wf.validation.required || wf.validation.success) {
        if (!wf.workflowCall.started) {
          this.props.workflowMethod(
            wf.workflowCall.workflow,
            wf.workflowCall.method,
            wf.workflowCall.reasonText
          );
          this.setState({ workingMessage: wf.workingMessage });
        } else {
          // Not finished, wait 2 seconds and re-check the status
          setTimeout(
            () => {
              // SD-14745 getWorkflowStatus was being called rampantly.
              // Unclear why there are so many calls get initiated, but throttle them down.
              const now = moment();
              const lastStarted = this.fetchingWorkflowStatus.started;
              if (lastStarted && now.diff(lastStarted, "milliseconds") < 1900) return;
              this.fetchingWorkflowStatus.running = true;
              this.fetchingWorkflowStatus.started = now;
              this.props.getWorkflowStatus(this.props.controlNumber);
            },
            2000
          );
        }
      }
    }
  }

  displayAddTimeLogs() {
    const { method, timeLogs, canUserAddTimeLog } = this.props;
    if (canUserAddTimeLog && method === "APPRAISAL_SUBMITTED" && Array.isArray(timeLogs)) {
      if (timeLogs.length === 0) {
        return true;
      } else {
        // If there are no time logs in the current pay period then display otherwise don't
        return !timeLogs.some(t => new Date(t.payPeriod.toDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0));
      }
    }
    return false;
  }

  hideActionDialog() {
    let workflowMonitor = {
      controlNumber: 0,
      display: false,
      workingMessage: "",
      started: false,
      finished: false,
      validation: {
        required: false,
        started: false,
        finished: false,
        success: false
      },
      workflowCall: {
        initialWorkflowStatusId: 0,
        method: "",
        workflow: "",
        reasonText: "",
        started: false,
        finished: false,
        success: false
      }
    };

    // action will trigger workflow call
    this.props.setWorkflowMonitor(workflowMonitor);
    this.props.refreshMethod();
    this.setState({ isVisible: false });

    if (this.props.workflowStatus.appraisalWorkflowStatusId === appraisalWorkflowStatusTypeEnum.GAAR_PREVIEW_ERROR_APPRAISER ||
        this.props.workflowStatus.appraisalWorkflowStatusId === appraisalWorkflowStatusTypeEnum.VEROS_PREVIEW_ERROR_APPRAISER) {
          this.props.scrollToAppraisalReviewCard();
    }

  }

  // Collateral Analytics - SSO Integration using the C/A website
  // -------------------------------------------------------------------------------------------
  showCollateralAnalyticsSso() {
    const { controlNumber } = this.props;
    if (controlNumber === 0) return;
    generateSsoParametersRiskProfiler(controlNumber,
        (caSsoParameters) => {
          this.showCollateralAnalyticsSsoWindow(caSsoParameters);
        }, (e) => {
          this.makeErrorToast(e, "error");
        }, this.mounted);
  }

  showCollateralAnalyticsSsoWindow(caSsoParameters) {
    let windowFeatures = "width=1300,height=768,scrollbars=yes,resizable=yes,top=100,left=100";
    if (window.innerHeight < 768 && window.innerHeight > 200) {
      windowFeatures = windowFeatures.replace("768", window.innerHeight - 200);
    }
    if (window.innerWidth < 1300 && window.innerWidth > 200) {
      windowFeatures = windowFeatures.replace("1300", window.innerWidth - 200);
    }

    // open the window catching the windowHandle and detect when it is deceased
    window.open(`${caSsoParameters.ssoSignOnUrl}?${caSsoParameters.ssoSignOnUrlQuerystring}`, "mueller-collateral-analytics-sso-risk-profiler", windowFeatures);
  }

  showActionDialog() {
    const { method } = this.props;
    switch (method) {
      case COLLATERAL_ANALYTICS_RISK_PROFILER:
        this.showCollateralAnalyticsSso();
        break;
      default:
        if (this.displayAddTimeLogs()) {
          this.setState({addTimeLogsDialogBoxVisible: true});
        } else {
          this.setState({isVisible: true});
        }
        break;
    }
  }

  checkForFeedback() {
    const { timeLogFeedback, method } = this.props;
    if(timeLogFeedback && timeLogFeedback.required && method === "APPRAISAL_SUBMITTED") {
      this.setState({displayFeedbackDialog: true});
    } else {
      this.confirmHandler();
    }
  }

  confirmHandler() {
    if (this.state.appraiserRejections.length && this.state.appraiserRejections.some(r => r.statusName.toLowerCase() === "open")) return this.props.makeErrorToast("Open QA Rejection must be closed before this appraisal can be submitted - please contact your manager.");
    const reasonText = this.state.commentFieldValue;
    const workflowMethod = this.state.alternateMethod ?? this.props.method;

    let workflowMonitor = {
      controlNumber: this.props.controlNumber,
      display: true, // Set to false after operation(s) are finished
      workingMessage: "Working on " + this.props.buttonText,
      initiatedByButtonText: this.props.buttonText,
      started: true,
      finished: false,
      validation: {
        required: this.props.showValidationStatus,
        started: false,
        finished: false,
        success: false
      },
      workflowCall: {
        initialWorkflowStatusId: this.props.workflowStatus.appraisalWorkflowStatusId,
        method: workflowMethod,
        workflow: this.props.workflow,
        reasonText: reasonText,
        started: false,
        finished: false,
        success: false
      }
    };

    // action will trigger workflow call
    this.fetchingWorkflowStatus.initiatedCall = true;
    this.props.setWorkflowMonitor(workflowMonitor);
    this.displayAppraisalSurvey();
  }

  getElementIdSuffix(w, m) {
    return (w + " " + m).toLowerCase().replace(" ", "-");
  }

  displayAppraisalSurvey() {
    // Collect appraiser satisfaction survey if rating does not already exist and only is user is an appraiser
    const { isFeedbackRequired } = this.state;
    const { canSubmitAppraiserFeedback } = this.props;
    if (!isFeedbackRequired && canSubmitAppraiserFeedback) {
      this.setState({ displayingAppraisalSurvey: true });
    }
  }

  submitAppraisalRatingSurvey() {
    const { fieldRepRating, operationsManagerRating, muellerTechRating, ratingComment } = this.state;
    const { makeErrorToast } = this.props;
    if (!fieldRepRating.stars || !operationsManagerRating.stars || !muellerTechRating.stars) {
      return makeErrorToast("Please select a star rating before submitting.");
    }
    if (ratingComment.length > 500) {
      return makeErrorToast("You have exceeded the character limit of 500.");
    }
    this.startSubmitAppraiserRating();
  }

  startSubmitAppraiserRating() {
    const { controlNumber, makeErrorToast } = this.props;
    const { fieldRepRating, operationsManagerRating, muellerTechRating, ratingComment } = this.state;
    this.setState({ displayingAppraisalSurvey: false });
    let bulkCaseFeedback = [fieldRepRating, operationsManagerRating, muellerTechRating];
    bulkCaseFeedback.forEach(item => {
      item["comments"] = ratingComment;
    });
    if (controlNumber) {
      postAppraiserFeedback(controlNumber, bulkCaseFeedback, err => err);
      makeErrorToast("Thank you for your feedback.");
      return;
    } else {
      makeErrorToast("Unable to collect your feedback.");
      return;
    }
  }

  showRejectToQaDialog() {
    let children = [<div key={"reject-to-QA-container"}>
      <TextField
        id={"reject-to-QA-controlNum"}
        className={"reject-to-QA-controlNum"}
        variant="standard"
        label={"Control #"}
        value={this.props.controlNumber}
      />
      <MSelect
        id={"reject-to-QA-reason"}
        className={"reject-to-QA-reason"}
        options={appraiserReasonOptions}
        onChange={reason => this.setState({ rejectToQaReason: reason.value })}
        isClearable={false}
        isMulti={false}
        enablePortal
        getMenuPortalTarget={() => document.querySelector("reject-to-QA-reason")}
      />
      <TextField
        id={"reject-to-QA-notes"}
        className={"reject-to-QA-notes"}
        variant="standard"
        label={"Notes"}
        multiline
        rows={10}
        onChange={(e) => this.setState({ rejectToQaNotes : e.target.value  })}
      />
    </div>];
    let actions = [{
      key: "saveChanges",
      label: "Save",
      isPrimary: true,
      onClick: () => {
        let newRejection = {
          controlIdNumber: this.props.controlNumber,
          reasonTypeCode: this.state.rejectToQaReason,
          note: this.state.rejectToQaNotes
        };
        addAppraiserRejections(this.props.controlNumber, newRejection, this.mounted, () => this.props.makeSuccessToast("Rejection sent to QA."));
        this.setState({ rejectToQaReason: null, rejectToQaNotes: null });
      }
    }, {
      key: "cancelChanges",
      label: "Cancel",
      isPrimary: false,
      onClick: () => this.setState({ rejectToQaReason: null, rejectToQaNotes: null })
    }];
    let dialogProps = { className: "reject-to-QA" };
    this.context.show("Reject to QA", children, actions, dialogProps);
  }

  render() {
    const { displayingAppraisalSurvey, fieldRepRating, operationsManagerRating, muellerTechRating } = this.state;
    const {
      buttonText,
      workflow,
      method,
      commentRequired,
      showValidationStatus,
      validationStatus,
      workflowMonitor,
      workflowStatus,
      showTimeLogDialog,
      profile,
      buttonOptions,
      isAppraisal,
    } = this.props;

    let wf = workflowMonitor;
    let inProgress = wf.display;
    let errorMessage = null;
    let useErrorStyle = false;
    let isStillWaiting = false;
    if (inProgress) {
      if (
        wf.validation.required &&
        wf.validation.finished &&
        !wf.validation.success
      ) {
        errorMessage = "There are form validation errors.";
        useErrorStyle = true;
      } else if (wf.workflowCall.finished) {
        if (wf.workflowCall.success) {
           errorMessage = "Completed successfully!";
        } else {
          errorMessage = "Finished with error(s).";
          useErrorStyle = true;
        }

        switch (workflowStatus.appraisalWorkflowStatusId) {
          case appraisalWorkflowStatusTypeEnum.VEROS_PREVIEW_REQUESTED:
          case appraisalWorkflowStatusTypeEnum.GAAR_PREVIEW_REQUESTED:
          case appraisalWorkflowStatusTypeEnum.APPRAISAL_SUBMITTAL_VERIFICATION:
            isStillWaiting = true;
            break;
          case appraisalWorkflowStatusTypeEnum.GAAR_PREVIEW_ERROR_APPRAISER:
            errorMessage = "GAAR Submission Complete. Please review results.";
            break;
          case appraisalWorkflowStatusTypeEnum.VEROS_PREVIEW_ERROR_APPRAISER:
            errorMessage = "Veros Submission Complete. Please review results.";
            break;
        }
      }
    }

    const initiatedCall = wf.initiatedByButtonText === buttonText && this.mounted.current;
    const disableButton = this.props.disabled || (initiatedCall && wf.workflowCall.started && !wf.workflowCall.finished);

    const methods = [];
    if (errorMessage) {
      errorMessage = (
        <div className={"working-message"}>
          <div
            className={useErrorStyle ? "validation-error" : "success"}
            style={{ textAlign: "center", fontSizeAdjust: "larger" }}
          >
            {isStillWaiting ? <MSpinner /> : errorMessage}
            <br />
            {isAppraisal && <>Status: <strong>{workflowStatus.message}</strong></>}
          </div>
        </div>
      );
      if (!isStillWaiting) {
        methods.push(
          <Button variant="text" color="secondary" onClick={this.hideActionDialog}>
            Close
          </Button>
        );
      }
    } else if (!inProgress) {
      methods.push(
        <Button
          variant="text"
          color="secondary"
          disabled={inProgress}
          onClick={this.hideActionDialog}
        >
          Cancel
        </Button>
      );
      methods.push(
        <Button
          disabled={inProgress}
          onClick={this.checkForFeedback}
        >
          Confirm
        </Button>
      );
    } else if (wf.workflowCall.finished) {
      methods.push(
        <Button variant="text" color="secondary" onClick={this.hideActionDialog}>
          Close
        </Button>
      );
    }

    let caseButtonText = buttonText;
    let dialogTitle = buttonText;
    let suffix = this.getElementIdSuffix(workflow, method);
    const enterTimeLogDialogBoxActions = [];
    enterTimeLogDialogBoxActions.push(<Button key="cancel" variant="text" color="secondary" onClick={() => this.setState({ addTimeLogsDialogBoxVisible: false })}>Cancel</Button>);
    enterTimeLogDialogBoxActions.push(<Button key="add" onClick={showTimeLogDialog}>Add Time Log</Button>);
    let actionControl = (<Button
        id={"action-" + suffix}
        disabled={disableButton}
        onClick={this.showActionDialog}
    >
      {caseButtonText}
    </Button>);
    /*
    if (buttonOptions?.Length){
      actionControl = (<DropdownButton
          id={"action-" + suffix}
          raised
          primary
          disabled={disableButton}
          onClick={this.showActionDialog}
      >
        {buttonOptions.map(a => (
        <CaseAction
            key={a.code}
            buttonText={a.buttonText}
            disabled={disabled}
            controlNumber={controlNumber}
            validateForms={validateForms}
            workflow={workflow}
            method={a.code}
            commentRequired={a.commentRequired}
            showValidationStatus={a.showValidationStatus}
            validationStatus={validationStatus}
            refreshMethod={refreshMethod}
            canUserAddTimeLog={canUserAddTimeLog}
            timeLogs={timeLogs}
            timeLogFeedback={timeLogFeedback}
            showTimeLogDialog={showTimeLogDialog}
            scrollToAppraisalReviewCard={scrollToAppraisalReviewCard}
            buttonOptions={a.options}
        />
        ))}
      </DropdownButton>
      );
    }
    */
    return (
      <div className="case-action">
        {actionControl}
        {profile.rights.includes(APPRAISER_ADD_INCIDENT) && <Button
          id={"reject-to-QA"}
          onClick={this.showRejectToQaDialog}
        >Reject to QA</Button>}
        {method === "APPRAISAL_SUBMITTED" && <Dialog
          open={this.state.addTimeLogsDialogBoxVisible}
          onClose={this.hideEnterTimeLogDialog}
          id="enter-timelog-dialog-box"
          sx={{ '& .MuiDialog-paper': { width: 500 } }}
        >
          <DialogTitle>Submit Appraisal</DialogTitle>
          <DialogContent>
            <div>Please add time log before submitting!</div>
          </DialogContent>
          <DialogActions>
            {enterTimeLogDialogBoxActions}
          </DialogActions>
        </Dialog>}
        <Dialog
          open={this.state.isVisible}
          onClose={this.hideActionDialog}
          id={"action-" + suffix + "-dialog"}
          className="case-action-dialog-submit"
          sx={{ '& .MuiDialog-paper': { width: 500 } }}
        >
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent>
          {errorMessage ? errorMessage : null}
          {inProgress && !errorMessage ? (
            <div className="working-message">
              <MSpinner />
              <div style={{ textAlign: "center" }}>
                {this.state.workingMessage}
              </div>
            </div>
          ) : null}
          {!inProgress && showValidationStatus ? validationStatus : null}
          {!inProgress && commentRequired ? (
            <div>
              <p>
                A Reason or Comment must be provided when taking this action.
              </p>
              <TextField
                variant="standard"
                multiline
                rows={2}
                id={"action-" + suffix + "-comment-field"}
                label="Reason"
                placeholder="Reason..."
                onChange={(e) => this.setState({commentFieldValue: e.target.value})}
              />
            </div>
          ) : null}
          {!inProgress && method === "acepdrconverttoappraisal" && buttonOptions?.length ? (
              <div>
                <p>
                  Select the type or appraisal
                </p>
                <RadioGroup
                    name={"action-" + suffix + "-alternate-method"}
                    onChange={(e, altMethod) => this.setState({alternateMethod: altMethod})}
                    aria-required={true}
                >
                  {buttonOptions.map(a => (
                      <FormControlLabel key={a.code} value={a.code} control={<Radio />} label={a.buttonText} />
                  ))}
                </RadioGroup>
              </div>
          ) : null}
          </DialogContent>
          <DialogActions>
            {methods}
          </DialogActions>
        </Dialog>
        {/* Appraiser Satisfaction Survey Popup */}
        <div id="appraisal-rating-survey-container">
          <Dialog
            open={displayingAppraisalSurvey}
            id="appraisal-rating-survey-dialog"
            aria-label="Appraisal Satisfaction Survey"
            sx={{ '& .MuiDialog-paper': { width: 1000 } }}
          >
            <DialogContent>
              <img src={logo} alt="Mueller-Reports-logo" className="appraisal-rating-survey-logo" />
              <h6 className="appraisal-rating-survey-question">How satisfied are you with the data collected by the designated Field Representative?</h6>
              <StarRatings
                rating={fieldRepRating.stars}
                changeRating={(newRating1) => this.setState({ fieldRepRating: { categoryCode: categoryCodes.APPRAISER_ABOUT_FIELDREP, stars: newRating1 } })}
                starRatedColor="#E03D4C"
                starHoverColor="#CA2030"
              />
              <h6 className="appraisal-rating-survey-question">How satisfied are you with the communication from the Operations Manager on this order?</h6>
              <StarRatings
                rating={operationsManagerRating.stars}
                changeRating={(newRating2) => this.setState({ operationsManagerRating: { categoryCode: categoryCodes.APPRAISER_ABOUT_OPS_MANAGER, stars: newRating2 } })}
                starRatedColor="#E03D4C"
                starHoverColor="#CA2030"
              />
              <h6 className="appraisal-rating-survey-question">How satisfied are you with the Mueller technology on this order?</h6>
              <StarRatings
                rating={muellerTechRating.stars}
                changeRating={(newRating3) => this.setState({ muellerTechRating: { categoryCode: categoryCodes.APPRAISER_ABOUT_TECHNOLOGY, stars: newRating3 } })}
                starRatedColor="#E03D4C"
                starHoverColor="#CA2030"
              />
              <TextField
                id="dialog-appraisal-rating-comments"
                variant="standard"
                label="Comments:"
                inputProps={{ maxLength: 500 }}
                onChange={(e) => this.setState({ ratingComment: e.target.value })}
                sx={{ minWidth: 350, maxWidth: 350 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.submitAppraisalRatingSurvey}>Submit</Button>
            </DialogActions>
          </Dialog>
        </div>
        {this.state.displayFeedbackDialog &&
          <TimeLogFeedback
            timeLogFeedback={this.props.timeLogFeedback}
            callback={this.confirmHandler}
            controlNumber={this.props.controlNumber}
          />}
      </div>
    );
  }
}

CaseAction.propTypes = {
  buttonText: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  controlNumber: PropTypes.number.isRequired,
  workflow: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  workflowMethod: PropTypes.func.isRequired,
  workflowMonitor: PropTypes.object.isRequired,
  setWorkflowMonitor: PropTypes.func.isRequired,
  validateForms: PropTypes.func.isRequired,
  showValidationStatus: PropTypes.bool.isRequired,
  validationStatus: PropTypes.object,
  getWorkflowStatus: PropTypes.func.isRequired,
  fetchingWorkflowStatus: PropTypes.bool.isRequired,
  workflowStatus: PropTypes.object.isRequired,
  refreshMethod: PropTypes.func.isRequired,
  timeLogs: PropTypes.array,
  timeLogFeedback: PropTypes.object,
  canUserAddTimeLog: PropTypes.bool,
  showTimeLogDialog: PropTypes.func,
  makeErrorToast: PropTypes.func,
  makeSuccessToast: PropTypes.func,
  profile: PropTypes.object.isRequired,
  scrollToAppraisalReviewCard: PropTypes.func.isRequired,
  canSubmitAppraiserFeedback: PropTypes.bool,
  buttonOptions: PropTypes.array,
  isAppraisal: PropTypes.bool,
};

const mapStateToProps = state => {
  const workflowCallMethod = state.caseForms.workflowMonitor.workflowCall.method;
  let fetchingWorkflowStatus = state.caseForms.fetchingWorkflowStatus;
  if (workflowCallMethod === ACE_PDR_CONVERT_TO_APPRAISAL_1004_HYBRID ||
    workflowCallMethod === ACE_PDR_CONVERT_TO_APPRAISAL_70H) {
    fetchingWorkflowStatus = false;
  }
  return {
    workflowMonitor: state.caseForms.workflowMonitor,
    fetchingWorkflowStatus: fetchingWorkflowStatus,
    workflowStatus: state.caseForms.workflowStatus,
    profile: state.user.profile,
    canSubmitAppraiserFeedback: state.user.profile.rights.includes(APPRAISAL_SUBMIT_FEEDBACK_REQUIRED)
  };
};

const mapDispatchToProps = dispatch => ({
  workflowMethod(workflow, method, doc) {
    dispatch(workflowMethod(workflow, method, doc));
  },
  getWorkflowStatus(controlIdNumber) {
    dispatch(getWorkflowStatus(controlIdNumber));
  },
  setWorkflowMonitor(wf) {
    dispatch(setWorkflowMonitor(wf));
  },
  makeErrorToast: text => {
    responseHandler.customToast(text, "error", dispatch);
  },
  makeSuccessToast: text => {
    responseHandler.customToast(text, "success", dispatch);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseAction);
